
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinandheri() {



const cardData = {
  keyword: 'Cab Service in Andheri MIDC',
  heading: 'eTravo: Premier Corporate Cab Services in Andheri MIDC for Seamless Business Transportation',
  headingDescription: 'eTravo delivers premium corporate cab services in Andheri MIDC, catering to a diverse mix of IT firms, media houses, manufacturing units, and logistics centers. Known for its bustling commercial activity and connectivity to Mumbai’s prime zones, Andheri MIDC requires timely, secure, and flexible transport solutions. From employee shuttle services to luxury executive transfers, our fleet and service model are designed to suit various business needs. With round-the-clock support, trained drivers, and GPS-enabled vehicles, we help companies ensure efficient commutes and enhance employee experience across Andheri and surrounding areas.',

  top: 'Key Corporate & Industrial Locations in Andheri MIDC Served by eTravo',
  topPlaces: [
    {
      title: 'Technopolis Knowledge Park',
      description: 'A modern tech park housing software, BPO, and analytics firms. eTravo provides daily cab services for employees and leadership teams, with real-time tracking and time-slot optimization to streamline daily operations.'
    },
    {
      title: 'SEEPZ SEZ',
      description: 'One of India’s earliest special economic zones, SEEPZ houses IT giants and export-oriented units. Our transport services here include multi-shift operations, compliance-ready routing, and dedicated cabs for high-security zones.'
    },
    {
      title: 'Tunga International Business Park',
      description: 'This commercial center hosts MNCs and enterprise hubs. eTravo supports visitor logistics, business meeting cabs, and routine shuttle runs connecting nearby metro stations and business hotels.'
    },
    {
      title: 'Andheri Industrial Estate',
      description: 'A bustling zone with SMEs and manufacturing units. We assist in organized staff movement and inter-office travel, helping reduce late arrivals and improve overall operational efficiency.'
    },
    {
      title: 'Times Square Building',
      description: 'A modern office complex near Saki Naka, housing tech startups and consulting firms. eTravo’s executive cab offerings are frequently used for high-end business travel and airport-to-office coordination.'
    }
  ],

  services: [
    {
      name: 'Andheri MIDC Corporate Cab Rentals',
      description: 'Our corporate cab rentals in Andheri MIDC are crafted for businesses needing scalable, reliable transport. We offer short-term and long-term hire models with fixed billing, custom routes, and 24/7 availability. Perfect for project-based hires, factory setups, or company-wide commuting programs, our rentals eliminate the hassle of managing internal fleets. Whether you require 2 vehicles or 50, we scale with your needs. Service includes driver vetting, vehicle health checks, and route optimization.'
    },
    {
      name: 'Employee Transport Cab Andheri MIDC',
      description: 'We specialize in employee cab transport for offices running in multiple shifts across Andheri MIDC. Our cabs follow predefined pick-up and drop schedules with live tracking and panic button support for safety. We manage bulk transport for BPOs, media houses, and manufacturing staff with excellent reliability. Routes are regularly optimized based on live traffic data. This ensures minimum wait times and timely staff arrivals.'
    },
    {
      name: 'Business Cab Services Andheri MIDC',
      description: 'Whether your sales team needs mobility or you’re arranging transport for visiting auditors, our business cab service fits the bill. You get on-demand bookings, hourly rentals, and executive-level cars with trained chauffeurs. Trips within MIDC or to client offices across Mumbai are covered seamlessly. With clean interiors and courteous drivers, your staff or guests ride in comfort. Booking and tracking are available via app, web, or direct call.'
    },
    {
      name: 'Corporate Staff Cabs Andheri MIDC',
      description: 'These are structured services designed for transporting staff across various shifts or departments. We cater to companies needing large-scale employee movement, group pickups, and shift-specific deployment. Daily ride monitoring ensures attendance optimization and smooth start-of-day operations. Drivers follow standard protocols and dress codes. Perfect for IT, manufacturing, and finance sector employers with 24x7 teams.'
    },
    {
      name: 'Reliable Corporate Cab Service Andheri MIDC',
      description: 'Businesses choose eTravo for our consistency and proactive support. We offer always-on dispatch services, instant replacement in case of breakdowns, and full transparency in billing. Our reliability lies in automated route scheduling, disciplined driver behavior, and timely performance reports. We also provide monthly MIS reports for HR/Admin teams. Whether it’s 5 rides a day or 500, reliability remains our top metric.'
    },
    {
      name: 'AC Corporate Cabs Andheri MIDC',
      description: 'Our air-conditioned fleet is well-maintained, sanitized daily, and checked for comfort. Especially during Mumbai summers or peak traffic hours, these cabs ensure passengers arrive relaxed and fresh. Suitable for CXOs, staff, and clients alike. We offer premium variants (Innova, Honda City, Skoda) on request. AC is just part of the package — overall comfort is our benchmark.'
    },
    {
      name: 'Staff Pickup and Drop Cab Andheri MIDC',
      description: 'Designed for early morning or late-night staff, our pickup/drop services operate round-the-clock. We handle route planning, boarding checks, and even wait-time alerts. Drivers are GPS-tracked and trained in basic emergency protocols. Our aim is to reduce absenteeism and increase employee satisfaction. Clients receive daily logs and reports to monitor usage and punctuality.'
    },
    {
      name: 'Affordable Business Cab Rentals Andheri MIDC',
      description: 'If you’re a startup or an SME operating in Andheri MIDC, our affordable rental packages offer great value. Choose from  dedicated vehicle options based on your headcount. We support group hires and shift coordination without high monthly costs. No hidden charges — just transparent billing. Scale up or down monthly as per your business needs.'
    },
    {
      name: 'Executive Cab Services Andheri MIDC',
      description: 'Your senior leadership, investors, or international guests deserve a premium travel experience. We offer executive cars with plush interiors, dressed chauffeurs, and bottled water/WiFi (on request). Airport transfers, board meetings, or daylong events are handled with discretion and care. These rides reflect your company’s professionalism. Scheduling is flexible and cancellations are hassle-free.'
    },
    {
      name: 'Monthly Corporate Cab Rentals Andheri MIDC',
      description: 'Our monthly plans allow HR/Admin to fix staff routes, monitor daily rides, and reduce travel chaos. These are suitable for teams working out of Andheri MIDC across day/night shifts. You get priority support, fixed-rate contracts, and consistent driver allocation. Monthly plans also integrate with attendance systems if needed. Ideal for factories, call centers, and back-office units.'
    },
    {
      name: 'Industrial Area Employee Transport Andheri MIDC',
      description: 'For factories and warehouse units in Andheri MIDC, we provide high-volume staff transport that runs on industrial shift schedules. Cabs are deployed in batches and monitored centrally. The service includes roster updates, location alerts, and safety audits. Reduces HR coordination efforts and ensures workforce availability at the right time. Fully compliant with company transport policies.'
    },
    {
      name: 'Corporate Client Cabs Andheri MIDC',
      description: 'Client visits should reflect your business values — and eTravo ensures that. Our corporate client cabs include well-maintained sedans, professional drivers, and route familiarity. Whether you’re picking clients from airport hotels or dropping them after plant visits, we ensure comfort and professionalism. Branding options also available inside vehicles. Timely, elegant, and cost-effective.'
    },
    {
      name: 'Business Meeting Cabs Andheri MIDC',
      description: 'Heading to a vendor meeting or sales pitch? Book our fast-access meeting cabs to reach on time. These are point-to-point rides or hourly packages for local travel across Andheri and Mumbai. Optimized for peak hours and fast availability, our system ensures your meetings aren’t delayed by logistics. Book via app, call center, or corporate dashboard.'
    },
    {
      name: 'Andheri Industrial Area Cab Hire',
      description: 'Need a cab for just one day, one team, or one project? Our cab hire services cover temporary requirements without long contracts. Available in standard or premium models, with hourly/daily billing. Perfect for audits, inspections, new team onboarding, or event-based needs. Drivers are trained to handle local routes, ensuring fast and safe navigation.'
    },
    {
      name: 'Corporate Shuttle Cabs Andheri MIDC',
      description: 'Shuttle cabs are perfect for companies with large employee groups staying in common locations. We create fixed or dynamic routes with vehicle capacity matching. These rides are cost-efficient and monitored for punctuality. Shuttles operate between offices, metro stations, and residential zones. Ideal for mid-sized and large employers trying to reduce transport costs and improve employee retention.'
    }
  ],

  tableData: [
    ['Andheri MIDC Corporate Cab Rentals', 'Employee Transport Cab Andheri MIDC'],
    ['Business Cab Services Andheri MIDC', 'Corporate Staff Cabs Andheri MIDC'],
    ['Reliable Corporate Cab Service Andheri MIDC', 'AC Corporate Cabs Andheri MIDC'],
    ['Staff Pickup and Drop Cab Andheri MIDC', 'Affordable Business Cab Rentals Andheri MIDC'],
    ['Executive Cab Services Andheri MIDC', 'Monthly Corporate Cab Rentals Andheri MIDC'],
    ['Industrial Area Employee Transport Andheri MIDC', 'Corporate Client Cabs Andheri MIDC'],
    ['Business Meeting Cabs Andheri MIDC', 'Andheri Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Andheri MIDC', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Corporate Cab Services for Andheri MIDC",
    "WhyChoosedescription": "eTravo offers premium corporate cab solutions for businesses located in Andheri MIDC, one of Mumbai’s busiest commercial and industrial zones. Our services are designed to address the complex commuting patterns and traffic conditions typical of this area. We ensure timely, smooth, and professional transportation for your employees, helping to boost punctuality, safety, and overall work satisfaction."
  },
  {
    "WhyChooseheading": "Diverse Fleet to Suit Every Business Travel Requirement",
    "WhyChoosedescription": "Whether you need comfortable sedans for executives, spacious MUVs for team travel, or daily employee shuttles, our fleet is equipped to meet all corporate travel needs. Each vehicle is regularly maintained and driven by trained professionals to ensure safety and comfort."
  },
  {
    "WhyChooseheading": "Trained Drivers with Route Expertise in Andheri MIDC",
    "WhyChoosedescription": "Our drivers are highly familiar with Andheri MIDC’s routes, office complexes, and traffic patterns. Their local knowledge helps avoid congested zones and ensure timely pickups and drop-offs, contributing to a stress-free commute for your workforce."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Corporate Convenience",
    "WhyChoosedescription": "We provide flexible transportation solutions tailored for dynamic corporate operations—whether it's fixed-route employee travel, on-demand bookings, or long-term contracts. Our system is designed to adapt to your scheduling needs with ease and reliability."
  },
  {
    "WhyChooseheading": "GPS-Enabled Cabs for Real-Time Monitoring and Safety",
    "WhyChoosedescription": "All cabs are equipped with GPS tracking systems, enabling real-time monitoring of employee rides. This enhances safety, improves transparency for HR and operations teams, and allows for quick action in case of any route deviations or delays."
  },
  {
    "WhyChooseheading": "Transparent Billing System with Detailed Trip Reports",
    "WhyChoosedescription": "We offer a transparent, paperless billing system that includes detailed invoices with fare breakdowns and trip histories. This makes budgeting and reimbursement simple and hassle-free for corporate accounts teams."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Measures for Every Ride",
    "WhyChoosedescription": "We follow rigorous hygiene protocols, including regular sanitization of vehicles, health checks for drivers, and compliance with safety regulations—ensuring a secure travel environment for your employees, especially in high-density areas like Andheri."
  },
  {
    "WhyChooseheading": "Dedicated Account Management for Seamless Service",
    "WhyChoosedescription": "Our corporate clients are assigned dedicated account managers to ensure smooth operations, resolve queries promptly, and provide ongoing support tailored to your business’s transportation strategy."
  }
]
}

const faqData = [
  [
    {
      question: "Do your services cover all parts of Andheri MIDC?",
      answer: "Yes, our cab services comprehensively cover Andheri MIDC and its surrounding commercial areas, ensuring convenient pick-up and drop-off points."
    },
    {
      question: "Can we book recurring employee rides for our office in Andheri MIDC?",
      answer: "Absolutely. We offer recurring ride scheduling and shift-based transportation tailored for offices operating in Andheri MIDC."
    },
    {
      question: "Do you provide monthly billing with invoice details?",
      answer: "Yes, we offer clear monthly invoices with detailed trip logs, making it easy to manage and reconcile corporate travel expenses."
    },
    {
      question: "Are your drivers trained in corporate communication and conduct?",
      answer: "Yes, our drivers undergo training in corporate etiquette and customer service to ensure a professional experience."
    },
    {
      question: "How do you ensure passenger safety in high-traffic areas like Andheri?",
      answer: "We implement real-time GPS tracking, vehicle sanitization, driver screenings, and safety monitoring to ensure a secure and smooth journey."
    },
    {
      question: "Do corporate clients get personalized support for bookings?",
      answer: "Yes, every corporate client is assigned a dedicated account manager to handle bookings, custom requests, and urgent support."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Ashish Mehta",
    designation: "Admin Head, VisionCorp Technologies",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s corporate cab service in Andheri MIDC is punctual, well-managed, and hassle-free. Our employees enjoy a reliable and comfortable commute every day.”"
  },
  {
    name: "Ms. Neha Shah",
    designation: "HR Manager, Delta Media Pvt Ltd",
    rating: [1, 1, 1, 1, 1],
    text: "“The flexibility, real-time tracking, and hygiene protocols offered by eTravo make them the ideal corporate travel partner in Andheri MIDC.”"
  }
];





























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Andheri MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-andheri-midc.jpg",
  "description": "Reliable and affordable corporate cab service in Andheri MIDC for employee transport, business meetings, and industrial area commutes. Book AC corporate cabs with experienced drivers from eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7890"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-andheri-midc"
  }
};









    return (
        <div>
<Helmet>
  <title>Cab Service in Andheri MIDC | Corporate & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab service in Andheri MIDC for corporate staff transport, business meetings, and industrial area commutes. Affordable and reliable AC corporate cabs by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/65.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinandheri;